import { render, staticRenderFns } from "./ComSms.vue?vue&type=template&id=0ee8be0e&scoped=true&"
import script from "./ComSms.vue?vue&type=script&lang=js&"
export * from "./ComSms.vue?vue&type=script&lang=js&"
import style0 from "./ComSms.vue?vue&type=style&index=0&id=0ee8be0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee8be0e",
  null
  
)

export default component.exports